import React from "react";

export type ILocale = "pt-BR" | "en-US";
export type ITranslations = Record<string, Record<string, string>>;
export type II18nContextType = {
  locale: ILocale;
  setLocale: (locale: ILocale) => void;
  t: (key: string) => string;
};

export const I18nContext = React.createContext<II18nContextType | undefined>(
  undefined
);
